import styled from "@emotion/styled";

export const ScreenContainer = styled.div`
  padding: 0 2rem;
  overflow: hidden;
`;

export const Container = styled.div`
  display: grid;
`;

export const H1 = styled.h1`
  margin-top: 30px;
  padding: 20px 0px;
  text-align: left;
`;
export const SelectContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  margin-top: 60px;
  align-items: center;

  & form {
    width: 240px;
    justify-self: flex-end;
  }
`;

export const H3 = styled.h3`
  padding: 10px 0px;
  text-align: left;
`;
export const ProjectContainer = styled.div`

  `;

export const A = styled.a`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  width: fit-content;
  background-color: transparent;
  color: #080808;
  font-size: 18px;

  cursor: pointer;
`;

export const DisplayProjects = styled.div`
display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top:30px`;

  export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
